<div class="rdrx-content-container">
  <!-- contents -->
  @if (config.hasContentsMenuTab$ | async) {
    <button
      placement="bottom"
      data-automation-id="contents-toggle"
      [mheTooltip]="'contents.contents' | translate"
      mhe-button
      [purpose]="ButtonPurpose.Icon"
      (click)="toggleLeftDrawer()"
      >
      <i class="dpg-icon dpg-icon-listview"></i>
    </button>
  }

  <!-- navigation -->
  <reader-core-navigation
    [interfaceMode]="config.interfaceMode$ | async"
    [location]="config.location$ | async"
    [navigation]="config.navigation$ | async"
    [navigationType]="config.navigationType$ | async"
  ></reader-core-navigation>

  @if (
    !(singleRange$ | async).isSingleRange &&
    (config.assignment$ | async) !== 'review' &&
    (pageStartIndex$ | async) &&
    (pageEndIndex$ | async)
    ) {
    <div class="assignment-pages">
      {{ 'navigation.assignment_pages' | translate }}:
      <strong data-automation-id="assigned-page-range" class="page-range">{{ pageStartIndex$ | async
      }} - {{ pageEndIndex$ | async }}</strong>
    </div>
  }

  <div class="actions">
    @if (
      (singleRange$ | async).isSingleRange &&
      (config.assignment$ | async) !== 'review' &&
      ((pageStartIndex$ | async) || (pageEndIndex$ | async))
      ) {
      <div
        class="assignment-pages"
        >
        {{ 'navigation.assignment_page' | translate }}:
        <strong class="page-range">{{ (singleRange$ | async).pageRange }}</strong>
      </div>
    }

    @if (customButton$ | async; as customButton) {
      <button
        data-automation-id="toolbar-custom-button"
        placement="bottom"
        class="custom-button"
        mhe-button
        [purpose]="ButtonPurpose.Icon"
        [mheTooltip]="customButton.ariaLabel"
        (click)="customButtonClicked()"
        >
        <img [src]="customButton.icon" aria-hidden="true" />
        @if (customButton?.counter > 0) {
          <div class="badge-counter">{{ customButton?.counter }}</div>
        }
      </button>
    }
    <!-- search -->
    @if (config.search$ | async) {
      <button
        data-automation-id="toolbar-search-button"
        placement="bottom"
        [mheTooltip]="'search.search' | translate"
        mhe-button
        [purpose]="ButtonPurpose.Icon"
        (click)="toggleRightDrawer()"
        >
        <i class="dpg-icon dpg-icon-system-search"></i>
      </button>
    }

    <!-- font resizer -->
    @if ((config.fontResizer$ | async) && (renderModeAllowsFontResize$ | async)) {
      <reader-core-font-resizer></reader-core-font-resizer>
    }

    <!-- return -->
    @if (config.backButton$ | async) {
      <button
        placement="bottom"
        data-automation-id="go-to-previous-location"
        [mheTooltip]="'navigation.back_button' | translate"
        mhe-button
        [purpose]="ButtonPurpose.Icon"
        [disabled]="(readerStore.canNavigateBack$ | async) === false"
        (click)="previousLocation()"
        >
        <i class="dpg-icon dpg-icon-undo"></i>
      </button>
    }

    <!--print button-->
    @if (config.print$ | async) {
      @if (readerStore.pdfLoading$ | async) {
        <div class="pdf-loading-spinner">
          <mat-progress-spinner
            data-automation-id="pdf-loading-spinner"
            mode="indeterminate"
            [strokeWidth]="2"
            [diameter]="25"
            class="rdrx-primary"
            color="primary"
          ></mat-progress-spinner>
        </div>
      } @else {
        <button
          placement="bottom"
          data-automation-id="print-button"
          [mheTooltip]="'print.print' | translate"
          mhe-button
          [purpose]="ButtonPurpose.Icon"
          (click)="showPrintModal()"
          >
          <i class="dpg-icon dpg-icon-printer"></i>
        </button>
      }
    }

    <!-- overflow menu (kebob) -->
    <rdrx-overflow-menu></rdrx-overflow-menu>
  </div>
</div>
